<template>
    <div>

        <div v-if="loading">
            <div id="controls"></div>
            Loading ...
        </div>
        <div v-else>
            <!-- Display props error -->
            <div v-if='propsError'>
                <div v-for='error in errors' :key='error' class='text-danger'>{{ error }}</div>
            </div>

            <!-- If dont have eny error -->
            <div v-else>
                <div class="mt-3" style="display: block;">
                    <h4>{{ bank }}</h4>
                    <label for="description">Description</label>
                    <input v-if="description_editable" type="text" id="description" name="description" v-model='description' class="form-control">
                    <input v-else disabled type="text" :value="description" class="form-control">

                    <button :disabled='disabled' class="btn btn-lg btn-primary btn-block mt-2 submitMonetawebReq" @click='submit'>Submit</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Stripe',
  props: {
    name: String,
    return_url: String,
    language: String,
    bank: String,
    amount: String,
    token: String,
    data: String,
    submitForm: Boolean
    },
    data: function() {
      return {
      propsError:false,
      errors: [],
      description: '',
      validLanguage: 'auto',
      disabled: false,
      clicked: false,
      loading: false,
      description_editable: false
  };
    },
    created(){
        // when clicked change value and excecute watch for clicked
        this.clicked = !this.clicked;

        // return error if is any error in prop
        if( !this.$props.return_url ){
            this.errors.push('Return Url prop is required')
            this.propsError = true
        }
        if( !this.$props.bank ){
            this.errors.push('Bank prop is required')
            this.propsError = true
        }
        if( isNaN(this.$props.amount) ){
            this.errors.push('Amount prop need to be number in format 5.99 or 10')
            this.propsError = true
        }
        if( this.$props.amount.toString().split('.')[1] ){
            if( this.$props.amount.toString().split('.')[1].length > 2 ){
                this.errors.push('Amount prop need to be number in format 5.99 or 10')
                this.propsError = true
            }
        }
        if( this.$props.amount < 0.50 ) {
            this.errors.push('The amount must be at least 0.50.')
            this.propsError = true
        }
        if( !this.$props.amount ){
            this.errors.push('Amount prop is required')
            this.propsError = true
        }
        if( !this.$props.name ){
            this.errors.push('Name Stripe prop is required')
            this.propsError = true
        }
        if( !this.$props.token ){
            this.errors.push('Token missing')
            this.propsError = true
        }

        var languages_acepted = ["auto", "bg", "cs", "da", "de", "el", "en", "es", "et", "fi", "fr", "hu", "it", "ja", "lt", "lv", "ms", "mt", "nb", "nl", "pl", "pt", "pt-BR", "ro", "ru", "sk", "sl", "sv", "tr","zh"]

        if ( !languages_acepted.includes(this.$props.language) ) {
            this.validLanguage = 'auto';
        } else {
            this.validLanguage = this.$props.language;
        }
    },
    methods: {
        getScript: function() {
            var scriptTag = document.createElement('script'), // create a script tag
            firstScriptTag = document.getElementsByTagName('script')[0]; // find the first script tag in the document
            scriptTag.src = 'https://js.stripe.com/v3/'; // set the source of the script to your script
            firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
        },
        submit: function() {
            if (!this.propsError) {
                this.getScript();
                var self = this;

                this.disabled = true;


                axios.post('https://gtn-gateway.draft2017.com/api/v2/orders',{
                    amount: this.$props.amount,
                    method: this.$props.bank.toLowerCase(),
                    description: this.description,
                    language: this.validLanguage,
                    name: this.name,
                    return_url: this.$props.return_url
                },
                {
                    headers: {'Authorization': 'Bearer ' + this.$props.token}
                },
                )
                .then(response => {
                  // eslint-disable-next-line no-undef
                  let stripe = Stripe(response.data.stripe_secret);
                        stripe.redirectToCheckout({
                            sessionId: response.data.session
                        }).then(function (result) {
                            self.errors.push(result.error.message)
                            self.propsError = true
                            self.disabled = false
                        })
                    }
                )
                .catch(function (error) {
                    // handle error
                    self.errors.push(error.response.data.message)

                    // handle specific errors
                    if(error.response.data.errors.return_url) {
                        self.errors.push(error.response.data.errors.return_url[0])
                    }
                    if(error.response.data.errors.amount) {
                        self.errors.push(error.response.data.errors.amount[0])
                    }
                    if(error.response.data.errors.language) {
                        self.errors.push(error.response.data.errors.language[0])
                    }

                    self.propsError = true
                    self.disabled = false
                    // console.log(error.response.data.errors.amount[0]);
                });
            }
        }
    },
    watch: {
        clicked: function () {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                this.description = object.description ? object.description : '';

                this.description_editable = typeof object.description_editable != 'undefined' ? ( object.description_editable == true ? true : false) : true;

                // if ( object.method ) {
                //     if ( object.method.toUpperCase() == this.$props.bank ) {
                //         // fill inputs
                //         this.description = object.description ? object.description : '';
                //
                //         // autosubmit
                //         // if in props json data field autoSubmit is true
                //         // if( object.autoSubmit ) {
                //         //     if (this.$props.submitForm) {
                //         //         this.submit();
                //         //     }
                //         // }
                //     }
                // }
            }
        },
        submitForm: function (value) {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        if( object.autoSubmit ) {
                            if (value) {
                                this.submit();
                                if (!this.propsError) {
                                    this.loading = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#controls {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 15;
    top: 0;
    left: 0;
 }
</style>
